import { gql } from '@apollo/client'

export default gql(`
    mutation adminDisableUser( $email: String! $userId: String $project: String) {
        adminDisableUser(
            email: $email
            project: $project
            userId: $userId
        ) {
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
